// extracted by mini-css-extract-plugin
export default {"text":"rankText_text__Efh2A"};